import { FC } from 'react';

import styles from './CreateFreeMapDialog.module.scss';

type Props = {
  companyName: string;
  onSubmit: () => void;
};

const CreateFreeMapDialog: FC<Props> = ({ companyName, onSubmit }) => {
  return (
    <div className={styles.dialog_inner}>
      <p className={styles.dialog_alert_text}>{companyName}の無料マップURLを発行してよろしいですか？</p>
      <button className={styles.confirm_button} onClick={() => onSubmit()}>
        実行
      </button>
    </div>
  );
};

export default CreateFreeMapDialog;
